import { DecisionLabelColor } from "@redotech/redo-return-core-common/return-flow/decision-label-color";
import { RedoBadgeColor } from "../arbiter-components/badge/redo-badge";
import * as badgeColorCss from "../arbiter-components/badge/redo-badge-colors.module.css";
import * as lightModeCss from "../theme/component-colors-light.module.css";

export const decisionLabelBadgeColor: Record<
  DecisionLabelColor,
  RedoBadgeColor
> = {
  [DecisionLabelColor.gray]: "gray",
  [DecisionLabelColor.red]: "error",
  [DecisionLabelColor.orange]: "orange",
  [DecisionLabelColor.yellow]: "warning",
  [DecisionLabelColor.green]: "success",
  [DecisionLabelColor.blue]: "blue",
  [DecisionLabelColor.purple]: "purple",
  [DecisionLabelColor.pink]: "pink",
};

export function decisionLabelFillClassName(color: DecisionLabelColor): string {
  return [
    lightModeCss.lightMode,
    badgeColorCss.alternate,
    badgeColorCss[decisionLabelBadgeColor[color]],
  ]
    .filter((className): className is string => !!className)
    .join(" ");
}
